export default __webpack_public_path__ + "static/media/My_Final_Wishes_page.0088f4ba.pdf";